module.exports = __webpack_public_path__ + "img/chat_selected.4deac610.svg";